export const env = {
  production: true,
  APIUrl: '/api',
  mapbox: 'pk.eyJ1IjoibmVsc29uZWMiLCJhIjoiY2xiMWZmazZ5MGczMDNwazh0MDFvdzlhdCJ9.RvJj9n9SSSye8BcirFDEiA',
  segmentWriteKeyTesting: 'Vtd8mTY0fHAaqmImTbNfTeA1GmwjCHeW',
  segmentWriteKeyProduction: 'yI8MAML4tGY7cFyGWAJ5MbIXt1TbWEed',
};
